import IndexHeader from 'components/Headers/IndexHeader'
import IndexNavbar from 'components/Navbars/IndexNavbar'

import React from "react";
// Import your Navbar if needed
// import IndexNavbar from "components/Navbars/IndexNavbar.js";

const KeyboardTerms = () => {
    React.useEffect(() => {
        document.body.classList.add("index-page", "sidebar-collapse");
        document.documentElement.classList.remove("nav-open");
        window.scrollTo(0, 0);
        
        return function cleanup() {
            document.body.classList.remove("index-page", "sidebar-collapse");
        };
    }, []);

    return (
        <>
            {/* <IndexNavbar /> */}
            <div className="wrapper">
                <div className="main">
                    <div className="terms-container">
                        <header className="terms-header">
                            <h1>Terms of Use</h1>
                            <p className="last-updated">Last updated on: June 10, 2025</p>
                        </header>

                        <section className="terms-intro">
                            <h2>1. Introduction and Acceptance</h2>
                            <p>
                                These Terms of Use constitute an agreement between <strong>BUGUN SOFTWARE COMPANY LIMITED</strong> and you regarding your use of our apps.
                            </p>
                            <p className="highlight-box">
                                <strong>Important:</strong> By using our services, you signify that you have read, understood, and agreed to be bound by these terms. If you do not agree, you may not use our apps.
                            </p>
                        </section>

                        <section>
                            <h2>2. Update</h2>
                            <p>These terms may be updated from time to time. Your continued use of our services after changes take effect will be deemed as acceptance of the updated terms.</p>
                        </section>

                        <section>
                            <h2>3. Restrictions</h2>
                            <p>Unless expressly permitted, you must not:</p>
                            <ul className="legal-list">
                                <li>Copy, modify, or merge our apps with other programs.</li>
                                <li>Reverse engineer, disassemble, or decompile the software.</li>
                                <li>Distribute, sub-license, or rent the apps to third parties.</li>
                                <li>Remove copyright or proprietary notices.</li>
                                <li><strong>Do anything that may cause damage or involve illegal activities.</strong></li>
                            </ul>
                        </section>

                        <section>
                            <h2>6. Payment of the Subscription</h2>
                            <p>Subscriptions automatically renew unless canceled at least <strong>24 hours</strong> before the end of the current billing period.</p>
                            <div className="info-note">
                                Note: Subscriptions are non-transferable between platforms and are valid only for Android devices via Google Play Store.
                            </div>
                        </section>

                        <section>
                            <h2>10. Disclaimers and Warranties</h2>
                            <p>Services are provided <strong>“AS IS”</strong>. We do not warrant that:</p>
                            <ul className="legal-list">
                                <li>The services will be uninterrupted or error-free.</li>
                                <li>Any defects will be corrected.</li>
                                <li>The service is free of viruses or harmful components.</li>
                            </ul>
                        </section>

                        <section>
                            <h2>11. Governing Law</h2>
                            <p>These Terms shall be governed by the laws of the <strong>State of California, USA</strong>.</p>
                        </section>

                        <footer className="terms-footer">
                            <p>Questions? Contact us through our official support channels.</p>
                        </footer>
                    </div>
                </div>
            </div>
        </>
    );
}

export default KeyboardTerms;